export default "__VITE_ASSET__520bf4bf__"